import React from 'react';
import useFlatData from '../../../Base/Hooks/useFlatData';
import useInsuranceReports from '../../Hooks/useInsuranceReports';
// @ts-ignore
import styles from './ManagerInsuranceReportList.module.scss';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
import ManagerInsuranceReportListItem from './ManagerInsuranceReportListItem';
import ManagerInsuranceReportFilter from './ManagerInsuranceReportFilter';

interface Props {
	workplaceId: string;
}

const wrapperId = 'managerInsuranceReportsListWrapper';

const ManagerInsuranceReportList: React.FC<Props> = ({ workplaceId }) => {
	const {
		getFlatInsuranceReports,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	} = useInsuranceReports();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatInsuranceReports,
		{
			data: data?.insuranceReports?.data,
			totalPages: data?.insuranceReports?.meta?.totalPages,
			page: data?.insuranceReports?.meta?.page,
		},
		page,
		setPage,
		{
			workplaceId,
		},
	);

	return (
		<div className={styles.wrapper}>
			<ManagerInsuranceReportFilter onFilter={setFilter} />
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={item => (
						<ManagerInsuranceReportListItem
							item={item}
							onDelete={loadData}
							onReload={loadData}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default ManagerInsuranceReportList;
